const ButtonSubmissionSpinner = () => {
  return (
    <div className="ml-2 w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
  );
};

export default ButtonSubmissionSpinner;
